import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
    Budget,
    CreateCheckoutSessionDto,
    SessionUrlDto,
    IncreaseCreditsRequestDto,
    ChangeSubscriptionRequestDto,
    CreditsOverviewDto,
    DecreaseCreditsRequestDto,
    SubscriptionDto,
} from 'src/app/shared/models/credit-service-dtos';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CreditsService {
    private readonly REST_URL: string;

    constructor(private http: HttpClient) {
        this.REST_URL = environment.backendUrl + '/rest';
    }

    getUserBudget(userId: string) {
        const url = `${this.REST_URL}/credits/users/${userId}/budget`;
        return this.http.get<Budget>(url);
    }

    getOverviewForUser(userId: string) {
        const url = `${this.REST_URL}/credits/users/${userId}/overview`;
        return this.http.get<CreditsOverviewDto>(url);
    }

    changeSubscription(
        changeSubscriptionRequest: ChangeSubscriptionRequestDto
    ) {
        const url = `${this.REST_URL}/subscriptions`;
        return this.http.put<SubscriptionDto>(url, changeSubscriptionRequest);
    }

    increaseCredits(increaseCreditsRequest: IncreaseCreditsRequestDto) {
        const url = `${this.REST_URL}/credits/increase`;
        return this.http.patch<void>(url, increaseCreditsRequest);
    }

    decreaseCredits(decreaseCreditsRequest: DecreaseCreditsRequestDto) {
        const url = `${this.REST_URL}/credits/decrease`;
        return this.http.patch<void>(url, decreaseCreditsRequest);
    }

    getCurrentUserSubscription(userId: string): Observable<SubscriptionDto> {
        const url = `${this.REST_URL}/subscriptions/users/${userId}`;
        return this.http.get<SubscriptionDto>(url);
    }

    createCustomerPortalSession(): Observable<SessionUrlDto> {
        const url = `${this.REST_URL}/payment-provider/customer-portal`;
        return this.http.post<SessionUrlDto>(url, null);
    }

    createCheckoutSession(
        createCheckoutSessionDto: CreateCheckoutSessionDto
    ): Observable<SessionUrlDto> {
        const url = `${this.REST_URL}/payment-provider/checkout-session`;
        return this.http.post<SessionUrlDto>(url, createCheckoutSessionDto);
    }
}
